module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="gut-check__section gut-check__section--intro">\n    <img src="' +
__e( $.staticURL('gutcheck-icon.png') ) +
'" class="gut-check__icon" alt="gut check icon" />\n    <p>\n        Let\'s check that you\'ve included the details that will maximize\n        your chances of success for these jobs\n    </p>\n    <a href="#" class="gut-check__button js-gut-check-next">Continue</a>\n</div>\n';

}
return __p
}